/* =========================================================
   NAILSALA ACADEMY — IMAGE LIGHTBOX v2
   ========================================================= */

(function () {

  function initAcademyLightbox() {

    const lightbox = document.getElementById('AcademyLightbox');

    if (!lightbox) return;

    const stage =
      lightbox.querySelector('.academy-lightbox__stage');

    const lightboxImage =
      lightbox.querySelector('.academy-lightbox__image');

    const closeButton =
      lightbox.querySelector('.academy-lightbox__close');

    const zoomStatus =
      lightbox.querySelector('.academy-lightbox__zoom-status');

    if (!stage || !lightboxImage || !closeButton) return;


    /* =====================================================
       SETTINGS
       ===================================================== */

    const MIN_SCALE = 1;
    const MAX_SCALE = 5;
    const WHEEL_STEP = 0.25;

    let scale = 1;

    let translateX = 0;
    let translateY = 0;

    let startX = 0;
    let startY = 0;

    let dragStartX = 0;
    let dragStartY = 0;

    let startDistance = 0;
    let startScale = 1;

    let isDragging = false;

    let activeTrigger = null;

    let lastTap = 0;


    /* =====================================================
       HELPERS
       ===================================================== */

    function clamp(value, min, max) {

      return Math.min(
        Math.max(value, min),
        max
      );

    }


    function getDistance(point1, point2) {

      const x =
        point2.clientX - point1.clientX;

      const y =
        point2.clientY - point1.clientY;

      return Math.sqrt(
        (x * x) + (y * y)
      );

    }


    function updateTransform() {

      if (scale <= 1) {

        scale = 1;

        translateX = 0;
        translateY = 0;

      }

      lightboxImage.style.transform =
        `translate3d(${translateX}px, ${translateY}px, 0) scale(${scale})`;

      lightboxImage.classList.toggle(
        'is-zoomed',
        scale > 1
      );

      if (zoomStatus) {

        zoomStatus.textContent =
          `${Math.round(scale * 100)}%`;

      }

    }


    function resetZoom() {

      scale = 1;

      translateX = 0;
      translateY = 0;

      startDistance = 0;

      isDragging = false;

      lightboxImage.classList.remove(
        'is-dragging'
      );

      updateTransform();

    }


    /* =====================================================
       OPEN
       ===================================================== */

    function openLightbox(trigger) {

      if (!trigger) return;

      const sourceImage =
        trigger.matches('img')
          ? trigger
          : trigger.querySelector('img');

      if (!sourceImage) return;

      const fullSource =
        sourceImage.getAttribute(
          'data-academy-zoom-src'
        ) ||
        sourceImage.currentSrc ||
        sourceImage.src;

      if (!fullSource) return;

      activeTrigger = trigger;

      resetZoom();

      lightboxImage.src = fullSource;

      lightboxImage.alt =
        sourceImage.alt || '';

      lightbox.classList.add('is-open');

      lightbox.setAttribute(
        'aria-hidden',
        'false'
      );

      document.documentElement.classList.add(
        'academy-lightbox-open'
      );

      document.body.classList.add(
        'academy-lightbox-open'
      );

      requestAnimationFrame(function () {

        closeButton.focus({
          preventScroll: true
        });

      });

    }


    /* =====================================================
       CLOSE
       ===================================================== */

    function closeLightbox() {

      if (
        !lightbox.classList.contains('is-open')
      ) {
        return;
      }

      lightbox.classList.remove('is-open');

      lightbox.setAttribute(
        'aria-hidden',
        'true'
      );

      document.documentElement.classList.remove(
        'academy-lightbox-open'
      );

      document.body.classList.remove(
        'academy-lightbox-open'
      );

      resetZoom();

      lightboxImage.removeAttribute('src');

      lightboxImage.alt = '';

      if (
        activeTrigger &&
        typeof activeTrigger.focus === 'function'
      ) {

        activeTrigger.focus({
          preventScroll: true
        });

      }

      activeTrigger = null;

    }


    /* =====================================================
       TRIGGERS — EVENT DELEGATION
       Works with existing AND dynamically rendered images.
       ===================================================== */

    document.addEventListener(
      'click',
      function (event) {

        const trigger =
          event.target.closest(
            '[data-academy-lightbox]'
          );

        if (!trigger) return;

        /*
          Never treat anything inside the modal
          as a new trigger.
        */

        if (trigger.closest('#AcademyLightbox')) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        openLightbox(trigger);

      }
    );


    document.addEventListener(
      'keydown',
      function (event) {

        /*
          Close modal
        */

        if (
          event.key === 'Escape' &&
          lightbox.classList.contains('is-open')
        ) {

          event.preventDefault();

          closeLightbox();

          return;

        }

        /*
          Keyboard-open eligible image
        */

        if (
          event.key !== 'Enter' &&
          event.key !== ' '
        ) {
          return;
        }

        const trigger =
          event.target.closest(
            '[data-academy-lightbox]'
          );

        if (!trigger) return;

        if (trigger.closest('#AcademyLightbox')) {
          return;
        }

        event.preventDefault();

        openLightbox(trigger);

      }
    );


    /* =====================================================
       PREVENT IMAGE DRAG
       ===================================================== */

    document.addEventListener(
      'dragstart',
      function (event) {

        if (
          event.target.closest(
            '[data-academy-lightbox]'
          )
        ) {

          event.preventDefault();

        }

      }
    );


    /* =====================================================
       CLOSE BUTTON
       ===================================================== */

    closeButton.addEventListener(
      'click',
      function (event) {

        event.preventDefault();
        event.stopPropagation();

        closeLightbox();

      }
    );


    /* =====================================================
       BACKDROP CLOSE
       ===================================================== */

    stage.addEventListener(
      'click',
      function (event) {

        if (event.target === stage) {

          closeLightbox();

        }

      }
    );


    /* =====================================================
       DESKTOP — WHEEL ZOOM
       ===================================================== */

    stage.addEventListener(
      'wheel',
      function (event) {

        if (
          !lightbox.classList.contains(
            'is-open'
          )
        ) {
          return;
        }

        event.preventDefault();

        if (event.deltaY < 0) {

          scale += WHEEL_STEP;

        } else {

          scale -= WHEEL_STEP;

        }

        scale =
          clamp(
            scale,
            MIN_SCALE,
            MAX_SCALE
          );

        updateTransform();

      },
      {
        passive: false
      }
    );


    /* =====================================================
       DESKTOP — DOUBLE CLICK
       ===================================================== */

    lightboxImage.addEventListener(
      'dblclick',
      function (event) {

        event.preventDefault();
        event.stopPropagation();

        if (scale > 1) {

          resetZoom();

        } else {

          scale = 2;

          updateTransform();

        }

      }
    );


    /* =====================================================
       DESKTOP — DRAG/PAN
       ===================================================== */

    lightboxImage.addEventListener(
      'mousedown',
      function (event) {

        if (scale <= 1) return;

        event.preventDefault();

        isDragging = true;

        startX = event.clientX;
        startY = event.clientY;

        dragStartX = translateX;
        dragStartY = translateY;

        lightboxImage.classList.add(
          'is-dragging'
        );

      }
    );


    window.addEventListener(
      'mousemove',
      function (event) {

        if (!isDragging) return;

        translateX =
          dragStartX +
          (event.clientX - startX);

        translateY =
          dragStartY +
          (event.clientY - startY);

        updateTransform();

      }
    );


    window.addEventListener(
      'mouseup',
      function () {

        isDragging = false;

        lightboxImage.classList.remove(
          'is-dragging'
        );

      }
    );


    /* =====================================================
       MOBILE — PINCH + PAN
       ===================================================== */

    stage.addEventListener(
      'touchstart',
      function (event) {

        if (event.touches.length === 2) {

          event.preventDefault();

          startDistance =
            getDistance(
              event.touches[0],
              event.touches[1]
            );

          startScale = scale;

          isDragging = false;

          return;

        }

        if (
          event.touches.length === 1 &&
          scale > 1
        ) {

          startX =
            event.touches[0].clientX;

          startY =
            event.touches[0].clientY;

          dragStartX = translateX;
          dragStartY = translateY;

          isDragging = true;

        }

      },
      {
        passive: false
      }
    );


    stage.addEventListener(
      'touchmove',
      function (event) {

        if (event.touches.length === 2) {

          event.preventDefault();

          const newDistance =
            getDistance(
              event.touches[0],
              event.touches[1]
            );

          if (!startDistance) return;

          scale =
            startScale *
            (
              newDistance /
              startDistance
            );

          scale =
            clamp(
              scale,
              MIN_SCALE,
              MAX_SCALE
            );

          updateTransform();

          return;

        }

        if (
          event.touches.length === 1 &&
          isDragging &&
          scale > 1
        ) {

          event.preventDefault();

          translateX =
            dragStartX +
            (
              event.touches[0].clientX -
              startX
            );

          translateY =
            dragStartY +
            (
              event.touches[0].clientY -
              startY
            );

          updateTransform();

        }

      },
      {
        passive: false
      }
    );


    stage.addEventListener(
      'touchend',
      function (event) {

        if (event.touches.length < 2) {

          startDistance = 0;

        }

        if (event.touches.length === 0) {

          isDragging = false;

        }

        lightboxImage.classList.remove(
          'is-dragging'
        );

      }
    );


    /* =====================================================
       MOBILE — DOUBLE TAP
       ===================================================== */

    lightboxImage.addEventListener(
      'touchend',
      function (event) {

        if (event.changedTouches.length !== 1) {
          return;
        }

        const now = Date.now();

        if (now - lastTap < 300) {

          event.preventDefault();

          if (scale > 1) {

            resetZoom();

          } else {

            scale = 2;

            updateTransform();

          }

          lastTap = 0;

          return;

        }

        lastTap = now;

      },
      {
        passive: false
      }
    );


    /* =====================================================
       SHOPIFY THEME EDITOR SUPPORT
       ===================================================== */

    document.addEventListener(
      'shopify:section:load',
      function () {

        /*
          Event delegation means newly rendered
          lightbox triggers work automatically.
          Nothing needs to be re-bound.
        */

      }
    );

  }


  /* =======================================================
     INITIALIZE
     ======================================================= */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initAcademyLightbox
    );

  } else {

    initAcademyLightbox();

  }

})();